import { isObject } from '@tunein/web-utils';
import { toHttps } from '../../transforms/utils';
export function transformNowPlaying(data) {
    if (!(data && isObject(data) && (data.secondary || data.primary))) {
        return;
    }
    const { ads, boostPrimary, boostSecondary, classification, containerNavigation, follow, header, popup, primary, secondary, share, switch: switchAction, token, ttl, upsell, } = data;
    const { image: originalImage } = secondary || primary || {};
    const image = toHttps(originalImage || '');
    const nowPlaying = {
        ads,
        classification,
        header,
        primaryGuideId: primary ? primary.guideId : undefined,
        secondaryGuideId: secondary ? secondary.guideId : undefined,
        title: header.subtitle,
        subtitle: header.title,
        image,
        followOptions: follow?.options,
        switchAction,
        upsell,
        ttl: ttl * 1000,
        share,
        popup,
        containerNavigation,
    };
    if (boostPrimary) {
        const { guideId, image: stationImage } = boostPrimary;
        const { title, subtitle, image: boostImage, } = boostSecondary || boostPrimary;
        nowPlaying.boost = {
            guideId,
            title,
            subtitle,
            image: toHttps(boostImage),
            stationImage: toHttps(stationImage),
        };
    }
    if (primary) {
        nowPlaying.primary = {
            title: primary.subtitle,
            subtitle: primary.title,
            image: primary.image,
        };
    }
    return { nowPlaying, token };
}
